var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentWhiteBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25150",
    "data-name": "Rechteck 25150",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19839",
    "data-name": "Gruppe 19839",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291184",
    "data-name": "Pfad 291184",
    d: "M8.5,22.075a.578.578,0,0,1-.575-.575V18.033a.959.959,0,0,0-.958-.958H4.034a2.111,2.111,0,0,1-2.109-2.108V4.033A2.111,2.111,0,0,1,4.034,1.925H19.967a2.112,2.112,0,0,1,2.109,2.108V14.967a2.112,2.112,0,0,1-2.109,2.108H14.593a.961.961,0,0,0-.645.249l-5.061,4.6a.581.581,0,0,1-.387.149m-4.466-19a.959.959,0,0,0-.958.958V14.967a.959.959,0,0,0,.958.958H6.967a2.112,2.112,0,0,1,2.109,2.108V20.2l4.1-3.728a2.11,2.11,0,0,1,1.418-.547h5.374a.959.959,0,0,0,.958-.958V4.033a.959.959,0,0,0-.958-.958Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentWhiteBorder);
export default __webpack_public_path__ + "static/media/comment_white_border.daf3df41000aee52ff738144e0e892aa.svg";
export { ForwardRef as ReactComponent };